import React from 'react';
import NodeList from '../Common/NodeList';
import CreateNodeDialog from '../Common/CreateNodeDialog';
import useInterfaceNodes from '../Common/useInterfaceNodes';

const MODULE_ID = 'ris';
const COLLECTION_ID = 'ris_merged';

const RisServers = ({ setReportRulesChanged }) => {
  const {
    nodes,
    dialogState,
    openDialog,
    closeDialog,
    handleSaved,
    loadCollectionNodes,
    handleTest,
    handlePingTest,
  } = useInterfaceNodes(MODULE_ID, COLLECTION_ID);

  return (
    <>
      <NodeList
        moduleId={MODULE_ID}
        collectionId={COLLECTION_ID}
        nodes={nodes}
        onAdd={() => openDialog()}
        onEdit={openDialog}
        onRefresh={loadCollectionNodes}
        onTest={handleTest}
        onPingTest={handlePingTest}
        setReportRulesChanged={setReportRulesChanged}
      />

      {dialogState.open && (
        <CreateNodeDialog
          open={dialogState.open}
          onClose={closeDialog}
          onSaved={handleSaved}
          initialData={dialogState.editingNode}
          moduleId={MODULE_ID}
          collectionId={COLLECTION_ID}
          setReportRulesChanged={setReportRulesChanged}
        />
      )}
    </>
  );
};

export default RisServers;
